/**
 * BootScene - Initialize game, ensure the UI font is loaded, then preload.
 */

import Phaser from 'phaser';
import { SCENES } from '../constants/GameConstants';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENES.BOOT });
  }

  async create(): Promise<void> {
    // Phaser renders canvas text with whatever the font is at draw time and does
    // not reflow when a web font loads late, so we wait for Outfit to be ready
    // before any scene draws text. Falls back gracefully if the API is missing.
    await this.ensureFontLoaded();
    this.scene.start(SCENES.PRELOAD);
  }

  private async ensureFontLoaded(): Promise<void> {
    const fonts = (document as any).fonts;
    if (!fonts || !fonts.load) return;
    try {
      await Promise.race([
        Promise.all([
          fonts.load('400 16px Outfit'),
          fonts.load('500 16px Outfit'),
          fonts.load('600 16px Outfit'),
          fonts.load('700 16px Outfit'),
          fonts.load('800 16px Outfit'),
        ]),
        // Never block boot for more than 3s if the font is slow/unavailable
        new Promise((resolve) => setTimeout(resolve, 3000)),
      ]);
      if (fonts.ready) await Promise.race([fonts.ready, new Promise((r) => setTimeout(r, 200))]);
    } catch {
      // Ignore — text will fall back to the system sans-serif
    }
  }
}
